import BlockHeader from "component/BlockHeader/BlockHeader";
import Footer from "component/Footer/Footer";
import Header from "component/Header/Header";
import { MessagingBox } from "component/MessagingBox";
import React from "react";
import { connect } from "react-redux";
import stateMap from "store/stateMap";
import {useSearchParams } from "react-router-dom";
import LoginBox from "component/LoginBox/LoginBox";
import { PageCredential } from "component/PageCredential";

const PageMessaging = connect(stateMap)(props => {
    let [searchParams]                          = useSearchParams();
    const SenderID                              = searchParams.get('mid');
    return (
        <>
            <Header/>
            <PageCredential title={`Messaging`}/>
                <div className="container">
                    <div className="w-800 mx-auto">
                        {
                            props.auth.user 
                            ? <MessagingBox chat_user={SenderID}/> 
                            : 
                            <div className="w-640 mx-auto">
                                <div className="text-center bold text-sm" style={{padding : '12px'}}>
                                    Login to see your message
                                </div>
                                <hr />
                                <br />
                                <div className="flex flex-wrap h-center">
                                    <LoginBox/>  
                                </div>
                            </div> 
                        }
                    </div>
                </div>
            <Footer/>
        </>
    )
});

export default PageMessaging;